export enum DateTypeFilterEnum {
  BUY_DATE = 'buyDate',
  DELIVERY_DATE = 'deliveryDate',
  BILLING_DATE = 'billingDate',
}
